import Hero from "components/views/PrivacyViews/Hero";
import PrivacyFirst from "components/views/PrivacyViews/PrivacyFirst/PrivacyFirst";
import PrivacySecond from "components/views/PrivacyViews/PrivacySecond/PrivacySecond";
import Privacythird from "components/views/PrivacyViews/PrivacyThird/PrivacyThird";
import PrivacyFourth from "components/views/PrivacyViews/PrivacyFourth/PrivacyFourth";
import PrivacyFifth from "components/views/PrivacyViews/PrivacyFifth/PrivacyFifth";
import PrivacySixth from "components/views/PrivacyViews/PrivacySixth/PrivacySixth";
import PrivacySeventh from "components/views/PrivacyViews/PrivacySeventh/PrivacySeventh";

const Privacy = () => {
  return (
    <>
      <Hero />
      <PrivacyFirst />
      <PrivacySecond />
      <Privacythird />
      <PrivacyFourth />
      <PrivacyFifth />
      <PrivacySixth />
      <PrivacySeventh />
    </>
  );
};

export default Privacy;
